import { assoc, modify } from 'ramda';
import { SETTINGS_AUTOCOMPLETE_KEY } from '../../../utility/settingsAccessor.config';
import { paramCtrlId, paramMode } from '../constants/parameterNames';
import { typeOption } from '../constants/parameterTypes';
import { AUTOCOMPLETE_MODE_DISABLE } from '../constants/viewSettingConstants';
import { getParamValue } from '../helpers/parameter.accessors';
import { success } from '../helpers/commandResult';

const description = 'Sets the autocomplete mode for a control or all controls.';

const requiredParameters = {
    [paramMode]: {
        description: `The autocomplete mode to use. Currently, only supported value is '${AUTOCOMPLETE_MODE_DISABLE}'.`,
        defaultValue: AUTOCOMPLETE_MODE_DISABLE,
        type: typeOption,
        options: [
            {
                name: 'Disable - Prevent suggestions when typing in the control and prevent auto-filling the control.',
                value: AUTOCOMPLETE_MODE_DISABLE,
            },
        ],
    },
};

const optionalParameters = {
    [paramCtrlId]: {
        description:
            "The id of the control to set the autocomplete mode on. If unspecified, the specified mode will be used for all controls that don't have an explicit autocomplete mode set.",
    },
};

const validateMode = (mode) => {
    switch (mode) {
        case AUTOCOMPLETE_MODE_DISABLE:
            return;
        default:
            throw new Error(`Invalid autocomplete mode: ${mode}`);
    }
};

const execute = ({ parameters, settings }) => {
    const mode = getParamValue(parameters, paramMode);
    const ctrlId = getParamValue(parameters, paramCtrlId);

    validateMode(mode);

    if (ctrlId) {
        settings.updateConfig(
            SETTINGS_AUTOCOMPLETE_KEY,
            modify('controls', assoc(ctrlId, mode)),
        );
    } else {
        settings.updateConfig(SETTINGS_AUTOCOMPLETE_KEY, assoc('mode', mode));
    }

    return success();
};

const SetAutocomplete = {
    description,
    requiredParameters,
    optionalParameters,
    execute,
};

export default SetAutocomplete;
